import React from "react";

const CommissionContext = React.createContext({
  commissions: undefined,
  setCommissions: () => {},
});

export default CommissionContext;
